// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messages {
  position: fixed;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
  align-items: flex-end;
  pointer-events: none;
}

.messagesMessage {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 8px 8px 14px;
  background: #262626;
  color: #fff;
  border-radius: var(--button-border-radius);
  box-shadow: 0 4px 16px #00000040;
  margin: 7px;
  font-size: var(--font-size-small);
  animation: fadein 200ms;
}

@media (min-width: 900px) {
  .messagesMessage {
    padding: 12px 12px 12px 18px;
  }
}

.messagesMessageText {
  max-width: 420px;
}

.messagesMessage code {
  background: #ffffff1f;
  color: inherit;
}

.messagesDismissButton {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  padding: 4px;
  border: 0;
  background: none;
  border-radius: var(--button-border-radius);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.5;
}

.messagesDismissButton:hover {
  background: #ffffff26;
  opacity: 1;
}

.messagesDismissButton:focus {
  outline: var(--outline-focus);
  opacity: 1;
}

.messagesDismissButton > img {
  width: var(--icon-size);
  height: var(--icon-size);
  filter: invert(1);
}

.messagesProgressBody {
  display: flex;
  min-width: 260px;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.messagesProgressBar {
  height: 6px;
  overflow: hidden;
  border-radius: 3px;
  background: #ffffff33;
}

.messagesProgressFill {
  height: 100%;
  border-radius: 3px;
  background: #fff;
  transition: width 120ms linear;
}

.messagesErrorList {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 6px 0 0;
  padding-left: 18px;
}

.messagesErrorPath {
  font-weight: 600;
  margin-right: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/frontend/components/Messages.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;EAChC,WAAW;EACX,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB","sourcesContent":[".messages {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column-reverse;\n  width: 100%;\n  align-items: flex-end;\n  pointer-events: none;\n}\n\n.messagesMessage {\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 8px 8px 14px;\n  background: #262626;\n  color: #fff;\n  border-radius: var(--button-border-radius);\n  box-shadow: 0 4px 16px #00000040;\n  margin: 7px;\n  font-size: var(--font-size-small);\n  animation: fadein 200ms;\n}\n\n@media (min-width: 900px) {\n  .messagesMessage {\n    padding: 12px 12px 12px 18px;\n  }\n}\n\n.messagesMessageText {\n  max-width: 420px;\n}\n\n.messagesMessage code {\n  background: #ffffff1f;\n  color: inherit;\n}\n\n.messagesDismissButton {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  padding: 4px;\n  border: 0;\n  background: none;\n  border-radius: var(--button-border-radius);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.5;\n}\n\n.messagesDismissButton:hover {\n  background: #ffffff26;\n  opacity: 1;\n}\n\n.messagesDismissButton:focus {\n  outline: var(--outline-focus);\n  opacity: 1;\n}\n\n.messagesDismissButton > img {\n  width: var(--icon-size);\n  height: var(--icon-size);\n  filter: invert(1);\n}\n\n.messagesProgressBody {\n  display: flex;\n  min-width: 260px;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n}\n\n.messagesProgressBar {\n  height: 6px;\n  overflow: hidden;\n  border-radius: 3px;\n  background: #ffffff33;\n}\n\n.messagesProgressFill {\n  height: 100%;\n  border-radius: 3px;\n  background: #fff;\n  transition: width 120ms linear;\n}\n\n.messagesErrorList {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin: 6px 0 0;\n  padding-left: 18px;\n}\n\n.messagesErrorPath {\n  font-weight: 600;\n  margin-right: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
